import React, { useContext } from 'react';
import './SolarSystem.css';
import ReactImg from '../../assets/React.png'
import NextIcon from '../../assets/Next.png'
import JS from '../../assets/js.png'
import Node from '../../assets/node.png'
import Express from '../../assets/express.png'
import Nest from '../../assets/nest.jpg'
import PSQL from '../../assets/PSQL.png'
import Mongo from '../../assets/mongo.png'
import AWS from '../../assets/aws.png'
import Github from '../../assets/github.png'
import Docker from '../../assets/docker.png'
import KN from '../../assets/kn.png'
import Firebase from '../../assets/firebase.png'
import Tailwind from '../../assets/tailwind.png'
import Typescript from '../../assets/typescript.png'
import GraphQL from '../../assets/graphql.png'
import Angular from '../../assets/angular.png'
import Webpack from '../../assets/webpack.jpg'
import CSS from '../../assets/css.png'
import HTML from '../../assets/html.png'
import { ThemeContext } from "../theme/ThemeProvider";

const SolarSystem = () => {
  const { theme } = useContext(ThemeContext);
  const rgbBackground = theme === "light" ? "#fff" : "#212b36";

  const items = [
    { name: 'React', image: ReactImg, className: 'react' },
    { name: 'Next.js', image: NextIcon, className: 'next' },
    { name: 'Docker', image: Docker, className: 'docker' },
    { name: 'JavaScript', image: JS, className: 'javascript' },
    { name: 'GitHub', image: Github, className: 'github' },
    { name: 'Node.js', image: Node, className: 'node' },
    { name: 'CI/CD', image: KN, className: 'kn' },
    { name: 'Express.js', image: Express, className: 'express' },
    { name: 'NestJS', image: Nest, className: 'nest' },
    { name: 'Firebase', image: Firebase, className: 'firebase' },
    { name: 'PostgreSQL', image: PSQL, className: 'psql' },
    { name: 'MongoDB', image: Mongo, className: 'mongo' },
    { name: 'AWS', image: AWS, className: 'aws' },
    { name: 'Tailwind', image: Tailwind, className: 'tailwind' },
    { name: 'TypeScript', image: Typescript, className: 'typescript' },
    { name: 'GraphQL', image: GraphQL, className: 'graphQL' },
    { name: 'Angular', image: Angular, className: 'angular' },
    { name: 'Webpack', image: Webpack, className: 'webpack' },
    { name: 'CSS', image: CSS, className: 'css' },
    { name: 'HTML', image: HTML, className: 'html' }
  ];
  return (
    <div id="tech" >
      <div className='parent'>

        <div className="space">
          <h1 className='heading' style={{ background: rgbBackground }}>Tech Stack</h1>
          <div className="solar-system">
            <div className="sun"></div>

            {items.map((item, index) => (
              <div
                key={index}
                className={`orbit ${item.className}`}
              >
                <img className='tech' src={item.image} />
              </div>
            ))}

          </div>
        </div>
      </div>
    </div>
  );
};

export default SolarSystem;
